<template>
  <footer>
    <div class="logo">
      <img :src="logo_img" alt="" class="logo-img" />
      <div class="location">
        <tr>
          <td>
            <img class="loc-img icons" :src="loc_img" alt="location" />
          </td>
          <td>
            <p class="p">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <img :src="phone_img" class="icons" alt="phone" />
          </td>
          <td>
            <p class="p">+1-543-123-4567</p>
          </td>
        </tr>
        <tr>
          <td><img :src="gmail_img" alt="email" class="icons" /></td>
          <td><p class="p">example@fylo.com</p></td>
        </tr>
      </div>
    </div>
    <div class="about">
      <tr>
        <td>
          <p>About Us</p>
        </td>
      </tr>
      <tr>
        <td><p>What We Do</p></td>
      </tr>
      <tr>
        <td><p>FAQ</p></td>
      </tr>
    </div>
    <div class="about">
      <tr>
        <td><p>Career</p></td>
      </tr>
      <tr>
        <td><p>Blog</p></td>
      </tr>
      <tr>
        <td><p>Contact Us</p></td>
      </tr>
    </div>
    <div class="social">
      <div class="icon-tr">
        <td class="social-td">
          <i class="fa fa-facebook-f icons socail-i"></i>
        </td>
        <td class="social-td"><i class="fa fa-twitter icons socail-i"></i></td>

        <td class="social-td">
          <i class="fa fa-instagram icons socail-i"></i>
        </td>
      </div>
      <tr>
        <td>
          <p class="copy">&copy; Copyright 2018 Huddle. All rights reserved.</p>
        </td>
      </tr>
    </div>
  </footer>
</template>
<script>
export default {
  name: "MyFooter",
  data() {
    return {
      logo_img: require("/src/assets/logo.svg"),
      loc_img: require("/src/assets/icon-location.svg"),
      phone_img: require("/src/assets/icon-phone.svg"),
      gmail_img: require("/src/assets/icon-email.svg"),
    };
  },
};
</script>
<style scoped>

.copy {
  color: white;
  text-align: center;
  font-size: 15px;
}
.fa {
  font-size: 20px;
  padding: 0.5rem;
  border: 2px #5c3535 solid;
  margin: 1rem;
  border-radius: 50%;
}
footer {
  display: flex;
}
.about > * {
  font-size: 18px;
  color: white;
  padding: 1rem;
}

td {
  padding: 1rem;
}
.logo-img {
  width: 12rem;
  margin: auto auto 1.5rem 1rem;
}
footer {
  background-color: hsl(192, 100%, 9%);
  padding-top: 10rem;
}
.logo {
  filter: invert(100%) sepia(46%) saturate(0%) hue-rotate(213deg)
    brightness(108%) contrast(100%);
  overflow: hidden;
}
.icons {
  filter: invert(100%) sepia(46%) saturate(0%) hue-rotate(213deg)
    brightness(108%) contrast(100%);
}
@media (max-width: 720px) {
  .p {
    font-size: 15px;
    font-weight: 550;
  }
  footer {
    flex-direction: column;
  }
  .icon-tr {
  width: fit-content;
  margin: auto;
}
}
@media (min-width: 721px) {
  footer {
    flex-direction: row;
    padding: 10rem 6rem 5rem 6rem;
  }
  .logo {
    width: 30%;
  }
  .about {
    width: 20%;
  }
}
</style>